import React, { useCallback } from 'react';
import { createPlugin } from 'react-plugin';
import { ControlPanel } from './ControlPanel.js';
const { namedPlug, register } = createPlugin({
    name: 'controlPanel',
    defaultConfig: {
        controlActionOrder: [],
    },
});
namedPlug('sidePanelRow', 'values', ({ pluginContext, slotProps }) => {
    const { controlActionOrder } = pluginContext.getConfig();
    const { getFixtureState, setFixtureState } = slotProps;
    const fixtureState = getFixtureState('controls');
    const onFixtureStateChange = useCallback(update => setFixtureState('controls', update), [setFixtureState]);
    return (React.createElement(ControlPanel, { fixtureState: fixtureState, controlActionOrder: controlActionOrder, onFixtureStateChange: onFixtureStateChange }));
});
export { register };
if (process.env.NODE_ENV !== 'test')
    register();
